/* Cristina Gavino: botones "+ Añadir" de la oferta 10% dentro de la cesta.
   Se carga con la página para que funcione aunque el bloque aparezca después (al añadir algo a la cesta). */
(function () {
  if (window.__cgCestaOferta) return;
  window.__cgCestaOferta = true;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cg-co-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var sel = btn.closest('.cg-co__item').querySelector('.cg-co__variante');
    var variante = sel ? sel.value : btn.dataset.variant;
    btn.disabled = true;
    var txt = btn.textContent;
    btn.textContent = 'Añadiendo…';
    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }], sections: 'cart-drawer-section' })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function (res) {
      if (btn.closest('[data-cg-co-pagina]')) { window.location.reload(); return null; }
      var html = res && res.sections && res.sections['cart-drawer-section'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('.cart-drawer__inner');
        var actual = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (nuevo && actual) actual.replaceWith(nuevo);
      }
      return fetch(raiz + 'cart.js').then(function (r) { return r.json(); });
    }).then(function (c) {
      if (!c) return;
      document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', c.item_count === 0); });
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = txt;
    });
  });
})();
